function initAjaxAddToCart() {
  document.querySelectorAll(".ajax-add-to-cart").forEach((form) => {
    if (form.classList.contains("ajax-bound")) return;
    form.classList.add("ajax-bound");

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      const formData = new FormData(form);
      const submitButton = form.querySelector(".add-to-cart-btn2");
      const btnText = submitButton?.querySelector(".btn-text");
      const spinner = submitButton?.querySelector(".loading__spinner");

      submitButton.disabled = true;
      btnText?.classList.add("hidden");
      spinner?.classList.remove("hidden");

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then(() => {
          return fetch("/?sections=cart-notification,cart-icon-bubble")
            .then((res) => res.json())
            .then((sectionData) => {
              const cartNotificationWrapper = document.getElementById("cart-notification");
              if (cartNotificationWrapper && sectionData["cart-notification"]) {
                cartNotificationWrapper.innerHTML = sectionData["cart-notification"];
              }

              const cartIconBubble = document.querySelector(".cart-icon-bubble");
              if (cartIconBubble && sectionData["cart-icon-bubble"]) {
                cartIconBubble.innerHTML = sectionData["cart-icon-bubble"];
              }

              setTimeout(() => {
                document.querySelector("cart-notification")?.open();
              }, 200);
            });
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
        })
        .finally(() => {
          submitButton.disabled = false;
          btnText?.classList.remove("hidden");
          spinner?.classList.add("hidden");
        });
    });
  });
}

function observeProductGridChanges() {
  const productGrid = document.querySelector('[id^="ProductGridContainer"]');
  if (!productGrid) return;

  const observer = new MutationObserver(() => {
    initAjaxAddToCart();
  });

  observer.observe(productGrid, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", () => {
  initAjaxAddToCart();
  observeProductGridChanges();
});

// Shopify Search & Discovery filter event
document.addEventListener("filters:updated", () => {
  initAjaxAddToCart();
});

// function showPriceAfterDelay() {
//   document.querySelectorAll(".spinner-container").forEach((spinner) => {
//     const price = spinner.nextElementSibling;

//     if (!price || !price.classList.contains("price-item2")) return;

//     // Prevent double init
//     if (price.dataset.shown === "true") return;

//     price.dataset.shown = "true"; // mark as handled

//     // After 4s, swap spinner with price
//     setTimeout(() => {
//       spinner.style.display = "none";
//       price.style.display = "inline";
//     }, 4000);
//   });
// }

// document.addEventListener("DOMContentLoaded", showPriceAfterDelay);
// document.addEventListener("filters:updated", showPriceAfterDelay);

// function showPriceAfterDelay() {
//   document.querySelectorAll(".spinner-container").forEach((spinner) => {
//     const price = spinner.nextElementSibling; // assumes price-item2 comes right after spinner

//     if (!price || !price.classList.contains("price-item2")) return;

//     // Reset state
//     spinner.style.display = "inline-block";
//     price.style.display = "none";

//     // Set timeout to reveal price after 4s
//     setTimeout(() => {
//       spinner.style.display = "none";
//       price.style.display = "inline";
//     }, 4000);
//   });
// }

// // Run on initial page load
// document.addEventListener("DOMContentLoaded", showPriceAfterDelay);

// // Re-run after filters update product grid
// document.addEventListener("filters:updated", showPriceAfterDelay);
